// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Tooltip overrides */\n#CorporateMetrics .tooltip .tooltip-inner {\n  min-width:420px;\n}\n.labelledBar h4 {\n  display:inline-block;\n}\n.labelledBar span {\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
